



export const  SV_DEF = {

   
      
    'EVENTS': {
        'ORDERTYPE_CHANGED': 'orderTypeChanged',
        'ACCOUNT_CHANGED': 'accountChanged',
        'ACCOUNTS_LOADED': 'accountsLoaded',
        'SNAPSHOT_LOADED': 'snapshotLoaded',
        'REFRESH_CLICKED': 'refreshClicked',
        'SYMBOL_CHANGED': 'symbolChanged',
        'QUANTITY_CHANGED': 'quantitychanged',
        'LASTPRICE_CHANGED': 'lastPricechanged',
      },
      SVMICROSERVICES:{
        SVENV_DEFAULT: 'DEV',
     
      },
     
             AF_TYPES:{
                 /*.  },
                             type: 'NUMBER'
     
                         }, {
     
                             name: 'hour',
                             value: 'hour',
                             range: {
                                 min: 0,
                                 max: 100
                             },
                             type: 'HH'
                         }, {
     
                             name: 'day',
                             value: 'day',
                             range: {
                                 list: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                                 min: 0,
                                 max: 100
                             },
                             type: 'WEEKDAY'
                         }, {
     
                             name: 'lln',
                             value: 'lln',
                             range: {
                                 min: 0,
                                 max: 100
                             },
                             type: 'TEXT' */
                    NUMBER:{
                        name:'NUMBER',
                        id:1
                    } ,
                    HH:{
                        name:'HH',
                        id:2
                    },
     
                     HH:{
                        name:'WEEKDAY',
                        id:3
                    },
                     TEXT:{
                        name:'TEXT',
                        id:4
                    },
                     DOUBLE:{
                        name:'DOUBLE',
                        id:5
                    },
                    DATE:{
                        name:'DATE',
                        id:6
                    },
                    TIME:{
                        name:'TIME',
                        id:7
                    },
     
                    DATETIME:{
                        name:'DATETIME',
                        id:8
                    }
     
             },
             'TOOLTIPS': {
                'Capital': {
                    'HEADER': 'Outgoing Packets',
                    'BODY': 'Includes the potential outgoing packets, packets recieved, packets  routed and udp recieved  packets that server may  receive  based on your current ntework configuration.'
                },
                'Income': {
                    'HEADER': 'Total Network Packets',
                    'BODY': 'Includes the potential lost packets, packetsc recieved, packets  routed and udp packets  , tcp packets server may expect to receive based on your current ntework configuration.'
                },
                'FloatingIP': {
                    'HEADER': 'Floating IP',
                    'BODY': 'Floating IP overcome the disadvantage of static IP . They enable  outgoing packets, packets recieved, packets  routed and udp recieved  packets that server may  receive  based on your current ntework configuration.'
                },
                'Firewall': {
                    'HEADER': 'Firewall Rules',
                    'BODY': 'Firewall Rules define constraints on  the potential outgoing packets, packets recieved, packets  routed and udp recieved  packets that server may  receive  based on your current ntework configuration.'
                }
            }
    

}